"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
const core_1 = require("@apitable/core");
const store_1 = require("../store");
const record_1 = require("./record");
class View {
    /**
     * @hidden
     */
    constructor(datasheetId, wCtx, viewData) {
        this.datasheetId = datasheetId;
        this.wCtx = wCtx;
        this.viewData = viewData;
    }
    /**
     * The unique ID of the view.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myView.id);
     * // => 'viwxxxxxx'
     * ```
     */
    get id() {
        return this.viewData.id;
    }
    /**
     * The name of the view.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myView.name);
     * // => 'Test View'
     * ```
     */
    get name() {
        return this.viewData.name;
    }
    /**
     * The type of the view.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myView.type);
     * // => 1
     * ```
     */
    get type() {
        return this.viewData.type;
    }
    /**
     * The url of the view.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myView.url);
     * ```
     */
    get url() {
        return `${window.location.origin}/workbench/${this.datasheetId}/${this.id}`;
    }
    /**
     * Get the specified record in the view.
     *
     * @param recordId The ID of the record.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myView.getRecordAsync('recxxxxxx')); // => Record
     * ```
     */
    getRecordAsync(recordId) {
        return new record_1.Record(this.datasheetId, this.wCtx, recordId);
    }
    /**
     * Batch get the records in the view.
     *
     * @param options.recordIds List of record IDs.
     *
     * @param options.sorts Which fields the records need to be sorted by.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myView.getRecordsAsync()); // => [Record, Record, ...]
     * console.log(myView.getRecordsAsync({ recordIds: ['recxxxxxx01', 'recxxxxxx02'] })); // => [Record, Record]
     * ```
     */
    getRecordsAsync(options) {
        var _a;
        const { rows } = this.viewData;
        if (!(rows === null || rows === void 0 ? void 0 : rows.length))
            return [];
        let finalRows;
        const state = this.wCtx.widgetStore.getState();
        const viewDerivate = core_1.ViewDerivateFactory.createViewDerivate(state, this.datasheetId, core_1.ViewType.Grid);
        const viewDerivation = viewDerivate.getViewDerivation(this.viewData);
        if (options == null || !((_a = options.recordIds) === null || _a === void 0 ? void 0 : _a.length)) {
            finalRows = viewDerivation.visibleRows;
        }
        else {
            const { recordIds } = options;
            finalRows = recordIds === null || recordIds === void 0 ? void 0 : recordIds.map(recordId => ({ recordId }));
        }
        const sorts = options === null || options === void 0 ? void 0 : options.sorts;
        if (sorts === null || sorts === void 0 ? void 0 : sorts.length) {
            const snapshot = (0, store_1.getSnapshot)(state, this.datasheetId);
            finalRows = core_1.Selectors.sortRowsBySortInfo(state, finalRows, sorts, snapshot);
        }
        return finalRows.map(({ recordId }) => {
            return new record_1.Record(this.datasheetId, this.wCtx, recordId);
        });
    }
}
exports.View = View;
